// Pure timing/format helpers for the REVEAL terminal — the server-rendered
// .tl[data-ms] spans that progressively reveal on replay, with an HONEST clock
// that counts real elapsed replay time.
//
// Salvaged in spirit from terminal_replay.js, but that engine's cast-inject model
// (parse JSON, write HTML on play) and its "Nm"/"Ns" gap formatter do not fit the
// reveal model, so only the timing arithmetic is carried across here as small,
// DOM-free, unit-testable functions.

// Honest elapsed clock as "M:SS.d" (minutes:seconds.tenths).
export function formatClock(ms) {
  const s = ms / 1000
  return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}.${Math.floor((s % 1) * 10)}`
}

// Real per-line delays (ms) from the reveal spans' data-ms, falling back to a
// default for any line missing or carrying a non-positive value — matching the
// prototype's `+l.dataset.ms || 300`.
export function readDelays(lines, fallback = 300) {
  return Array.from(lines, (l) => +l.dataset.ms || fallback)
}

// Total condensed replay duration (ms) for a delays array.
export function totalMs(delays) {
  return delays.reduce((a, b) => a + b, 0)
}
